export default {"src":"/_next/static/media/circleDamage_64.994e85c8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};